import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuex from 'vuex'
import store from './store'
import vuetify from './plugins/vuetify';
import AsyncComputed from 'vue-async-computed'
import {guard} from './router/guard/guard.index'
guard(store, router);

Vue.config.productionTip = false

Vue.use(Vuex)
Vue.use(AsyncComputed) 
const vueApp = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')

export default vueApp;